import React from 'react';

import {
  useBiopharmaGroupsState,
  useBiopharmaGroupsActions
} from './BiopharmaGroupsContext';

import {
  getBiopharmaGroups,
} from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const BiopharmaGroupsPageController = () => {
  const biopharmaGroupsState = useBiopharmaGroupsState();
  const { onResponse, onError } = useBiopharmaGroupsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return (
    <PageController
      pageNumber={biopharmaGroupsState?.pageNumber}
      numberOfPages={biopharmaGroupsState?.numberOfPages}
      goToFirstPage={() => {
        getBiopharmaGroups({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: 1,
            filterOptions: biopharmaGroupsState?.filterOptions,
          },
        });
      }}
      goToPreviousPage={() => {
        getBiopharmaGroups({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: (biopharmaGroupsState?.pageNumber - 1),
            filterOptions: biopharmaGroupsState?.filterOptions,
          },
        });
      }}
      goToNextPage={() => {
        getBiopharmaGroups({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: (biopharmaGroupsState?.pageNumber + 1),
            filterOptions: biopharmaGroupsState?.filterOptions,
          },
        });
      }}
      goToLastPage={() => {
        getBiopharmaGroups({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: biopharmaGroupsState?.numberOfPages,
            filterOptions: biopharmaGroupsState?.filterOptions,
          },
        });
      }}
    />
  );
};

export default BiopharmaGroupsPageController;
